export const TEST = 'TEST';
export const TARIFFS = 'TARIFFS';

export const SET_SUBTITLE_TEXT = 'SET_SUBTITLE_TEXT';

export const DEFAULT_PRODUCT_ID = 1;
